import type { FC, ComponentType } from 'react'
import { useContext } from 'react'
import { SupplierCalendarsContext } from 'contexts/SupplierCalendarsContext'
import { Route, Redirect, RouteProps } from 'react-router-dom'

interface ProtectedRouteProps extends RouteProps {
    // eslint-disable-next-line
    component: ComponentType<any>
    redirectTo: string
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ component: Component, redirectTo, ...rest }) => {
    const { calendarId, calendarsStatuses } = useContext(SupplierCalendarsContext)
    let isWorksheet = false

    if (calendarId && calendarsStatuses) {
        const currentCalendarStatus = calendarsStatuses?.[calendarId]
        isWorksheet = currentCalendarStatus === 'Worksheet'
    }

    // отключаем возможность редактирования утвержденных календарей
    // const isSuperAdmin = checkSuperAdminRole()
    const isSuperAdmin = false

    const hasAccess = isSuperAdmin || isWorksheet

    return (
        <Route
            {...rest}
            render={(props) =>
                hasAccess ? <Component {...props} /> : <Redirect to={redirectTo} />
            }
        />
    )
}

export default ProtectedRoute
